import script from "./AIAssistantReviewView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantReviewView.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantReviewView.vue?vue&type=style&index=0&id=a090247c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a090247c"]])

export default __exports__